import { GameCommunicationConnectionObserver as CoreGameCommunicationConnectionObserver } from '@pp/core/src/controllers/gameCommunication/GameCommunicationConnectionObserver';
import { GameConnectionStatus } from '@pp/core/src/services/gameCommunication/types';
import { SOCKET_CONNECTION_STATUS } from '@pp/core/src/services/webSocket/types';

import { fetchRecentResultsAction } from '../../store/apiActions/fetchRecentResultsAction';
import { GameStore } from '../../store/GameStore';
import { highflyerStateActions } from '../../store/slices/highflyerState/slice';

export class GameCommunicationConnectionObserver extends CoreGameCommunicationConnectionObserver {
  update(connectionStatus: GameConnectionStatus, store: GameStore): void {
    const recentResultsCount = store.getState().highflyerGameState.recentResultsCount;
    const session = store.getState().config.session;
    const JSESSIONID = session?.JSESSIONID;
    const tableId = session?.tableId;
    const baseUrl = session?.metaServer ?? session?.actualWebServer;

    switch (connectionStatus) {
      // If comes from reconnecting, reset the state
      case SOCKET_CONNECTION_STATUS.RECONNECTING:
        store.dispatch(highflyerStateActions.resetAfterReconnection());
        break;
      // If reconnected, re-fetch recent results
      case SOCKET_CONNECTION_STATUS.RECONNECTED:
      case SOCKET_CONNECTION_STATUS.CONNECTED:
        if (recentResultsCount && JSESSIONID && baseUrl && tableId) {
          store.dispatch(
            fetchRecentResultsAction({
              JSESSIONID,
              tableId,
              numberOfGames: recentResultsCount,
              url: `${baseUrl}/api/ui/statisticHistory`,
              force: true,
            })
          );
        }
        break;
      default:
        break;
    }
    super.update(connectionStatus, store);
  }
}
